import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { SubscriptionPlan } from '../../utils/subscription';

interface UserPlanBadgeProps {
  planType: number | null | undefined;
  sx?: object;
}

const baseSx = {
  display: 'inline-flex',
  alignItems: 'center',
  px: 0.7,
  py: 0.25,
  borderRadius: 1,
  border: '1px solid',
  fontSize: '0.62rem',
  fontWeight: 400,
  lineHeight: 1,
  color: '#fff',
  userSelect: 'none' as const,
};

const UserPlanBadge: React.FC<UserPlanBadgeProps> = ({ planType, sx = {} }) => {
  const plan = planType ?? 0;
  if (plan < SubscriptionPlan.PRO) return null;

  const isPlus = plan >= SubscriptionPlan.MAX;
  const label = isPlus ? 'PRO＋' : 'PRO';
  const tooltipText = isPlus ? 'PRO: MAX メンバー' : 'PRO: STANDARD メンバー';

  const tierSx = isPlus
    ? {
        background: 'linear-gradient(210deg, rgba(217,255,0,0.28) 0%, rgba(0,0,0,0.9) 60%)',
        borderColor: 'rgba(217,255,0,0.5)'
      }
    : {
        background: 'linear-gradient(210deg, rgba(255, 255, 255, 0.15) 0%, rgba(0,0,0,0.9) 60%) ',
        borderColor: 'rgba(255, 255, 255, 0.4)',
      };

  return (
    <Tooltip title={tooltipText} arrow>
      <Box component="span" sx={{ ...baseSx, ...tierSx, ...sx }}>{label}</Box>
    </Tooltip>
  );
};

export default UserPlanBadge;
